import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoChevronForward, IoChevronBackCircle } from '../../node_modules/react-icons/io5/index.esm.js';
import Container from '../Container/index.js';
import Button from '../Button/index.js';
import QuickActionButton from '../QuickActionButton/index.js';
import useBooleanState from '../../hooks/useBooleanState.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

var _IoChevronForward, _IoChevronBackCircle;

function CollapsibleContainer(props) {
  const {
    className,
    headerActions,
    expandButtonClassName,
    expandButtonContent = _IoChevronForward || (_IoChevronForward = /*#__PURE__*/React.createElement(IoChevronForward, null)),
    collapseButtonClassName,
    collapseButtonContent = _IoChevronBackCircle || (_IoChevronBackCircle = /*#__PURE__*/React.createElement(IoChevronBackCircle, null)),
    componentRef,
    collapsedInitially = false,
    ...otherProps
  } = props;
  const [isCollapsed, setIsCollapsedTrue, setIsCollapsedFalse, setIsCollapsed] = useBooleanState(collapsedInitially);
  React.useEffect(() => {
    if (componentRef) {
      componentRef.current = {
        setIsCollapsed
      };
    }
  }, [componentRef, setIsCollapsed]);
  return isCollapsed ? /*#__PURE__*/React.createElement(QuickActionButton, {
    className: expandButtonClassName,
    onClick: setIsCollapsedFalse,
    variant: "primary",
    name: undefined
  }, expandButtonContent) : /*#__PURE__*/React.createElement(Container, _extends({
    className: className,
    headerActions: /*#__PURE__*/React.createElement(React.Fragment, null, headerActions, /*#__PURE__*/React.createElement(Button, {
      variant: "action",
      className: _cs(styles.collapseButton, collapseButtonClassName),
      childrenContainerClassName: styles.children,
      onClick: setIsCollapsedTrue,
      name: undefined
    }, collapseButtonContent))
  }, otherProps));
}

var index = genericMemo(CollapsibleContainer);

export { index as default };
//# sourceMappingURL=index.js.map
